(function () {
  function init() {
    document.querySelectorAll('.istt2-proof__video').forEach(function (btn) {
      if (btn.dataset.isttVideoBound) return;
      btn.dataset.isttVideoBound = 'true';

      btn.addEventListener('click', function () {
        var id = btn.dataset.videoId;
        var hash = btn.dataset.videoHash;
        if (!id) return;
        var src = 'https://player.vimeo.com/video/' + id + '?autoplay=1&badge=0&autopause=0';
        if (hash) src += '&h=' + hash;
        var iframe = document.createElement('iframe');
        iframe.src = src;
        iframe.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;border:0;';
        iframe.allow = 'autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share';
        btn.innerHTML = '';
        btn.appendChild(iframe);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();